import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import "./DateRangePicker.css";

const { RangePicker } = DatePicker;

const CustomDatePicker = ({ onSelect, onClose, startDate, endDate }) => {
  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      onSelect({
        start: dateStrings[0],
        end: dateStrings[1]
      });
    } else {
      onSelect({
        start: null,
        end: null
      });
    }
  };

  const rangePresets = [
    { label: "Today", value: [dayjs(), dayjs()] },
    { label: "Yesterday", value: [dayjs().subtract(1, "day"), dayjs()] },
    { label: "Last Week", value: [dayjs().subtract(1, "week"), dayjs()] },
    { label: "Last Month", value: [dayjs().subtract(1, "month"), dayjs()] },
    { label: "Last Quarter", value: [dayjs().subtract(3, "months"), dayjs()] },
  ];

  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("day");
  };

  return (
    <RangePicker
      presets={rangePresets}
      onChange={onRangeChange}
      disabledDate={disableFutureDates}
      open={true}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      popupClassName="dateRangePicker"
      getPopupContainer={(trigger) => trigger.parentNode.parentNode}
      style={{ opacity: 0, position: 'absolute', right: 0 }}
      value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
    />
  );
};

export default CustomDatePicker;
